module.exports = __webpack_public_path__ + "static/media/signup-placements.4bbe6d82.svg";